module.exports = __webpack_public_path__ + "img/icon_del.72904ded.svg";